import { Phone, Mail } from "lucide-react";
import { Reveal } from "../Reveal";
import { CONTACT } from "../../lib/data";

export const Footer = () => {
  return (
    <footer
      id="contact"
      data-testid="footer-section"
      className="relative bg-[#0f0f0f] border-t border-white/10 pt-24 sm:pt-32 pb-10"
    >
      <div className="mx-auto max-w-[1500px] px-5 sm:px-8">
        <Reveal>
          <p className="text-xs font-bold uppercase tracking-[0.3em] text-[#e62429] mb-6">
            Or simply get in touch
          </p>
          <h2 className="font-display uppercase text-white text-6xl sm:text-8xl lg:text-[9vw] leading-[0.85]">
            Let's <span className="text-stroke-red">talk.</span>
          </h2>
          <p className="mt-6 text-lg text-neutral-400 max-w-lg">
            A conversation is usually a better place to start.
          </p>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 gap-5 max-w-3xl">
          <a
            href={`tel:${CONTACT.phoneHref}`}
            data-testid="footer-call-link"
            className="group flex items-center gap-5 border border-white/15 p-7 hover:bg-[#e62429] transition-colors duration-300"
          >
            <span className="flex h-14 w-14 shrink-0 items-center justify-center border border-white/30 group-hover:border-white/60 transition-colors">
              <Phone className="h-6 w-6" />
            </span>
            <span className="flex flex-col">
              <span className="text-[10px] uppercase tracking-[0.25em] font-bold text-neutral-400 group-hover:text-white/80">
                Call us
              </span>
              <span className="font-display text-2xl sm:text-3xl text-white">
                {CONTACT.phone}
              </span>
            </span>
          </a>

          <a
            href={`mailto:${CONTACT.email}`}
            data-testid="footer-email-link"
            className="group flex items-center gap-5 border border-white/15 p-7 hover:bg-[#e62429] transition-colors duration-300"
          >
            <span className="flex h-14 w-14 shrink-0 items-center justify-center border border-white/30 group-hover:border-white/60 transition-colors">
              <Mail className="h-6 w-6" />
            </span>
            <span className="flex flex-col overflow-hidden">
              <span className="text-[10px] uppercase tracking-[0.25em] font-bold text-neutral-400 group-hover:text-white/80">
                Email us
              </span>
              <span className="font-display text-xl sm:text-2xl text-white truncate">
                {CONTACT.email}
              </span>
            </span>
          </a>
        </div>

        <div className="mt-20 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6 border-t border-white/10 pt-8">
          <div className="flex flex-col items-start gap-3 leading-none">
            <img
              src="/owos-logo-badge.png"
              alt="One World of Sports"
              className="h-16 w-auto self-start shrink-0 object-contain"
            />
            <span className="text-[10px] tracking-[0.3em] text-neutral-500 font-bold">
              OWNED BY PURPOSE. DRIVEN BY PASSION.
            </span>
          </div>
          <p className="text-xs text-neutral-600 uppercase tracking-[0.2em]">
            © {new Date().getFullYear()} One World of Sports
          </p>
        </div>
      </div>
    </footer>
  );
};
